import { render } from "./RoleListSection.vue?vue&type=template&id=2543ed3c&scoped=true"
import script from "./RoleListSection.vue?vue&type=script&lang=js"
export * from "./RoleListSection.vue?vue&type=script&lang=js"

import "./RoleListSection.vue?vue&type=style&index=0&id=2543ed3c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2543ed3c"]])

export default __exports__